export const SMS_VERIFY_MAX_ATTEMPTS = 5;
export const SMS_RESEND_COOLDOWN_SECONDS = 60;
export const SMS_LOCAL_NUMBER_LENGTH = 10;
export const SMS_CODE_LENGTH = 6;
// Matches OtpService.VALID_SECONDS (the guaranteed floor) rather than the
// shipped SMS body's overstated "10 minutes" — see PhoneVerificationService.cs.
export const SMS_CODE_EXPIRY_SECONDS = 300;
// Identifies the exact on-screen consent wording the user agreed to. The verbatim text for this
// version is stored server-side (AppSettings.SmsConsentVersionText) for TCPA/SOC2 audit.
// IMPORTANT: any change to the on-screen consent disclosure/checkbox wording requires a NEW version
// key here AND a matching new entry on the BE (AppSettings.SmsConsentVersionText +
// AcceptedSmsConsentVersions). NEVER edit an existing version — that would misrepresent what
// already-consented users agreed to.
export const SMS_CONSENT_VERSION = "v1";

export const SMS_COUNTRY_OPTIONS: { id: string; name: string; dialCode: string }[] = [
    { id: "US", name: "US", dialCode: "1" },
    { id: "CA", name: "CA", dialCode: "1" },
];
